export function convertToCurrency(value) {
  return value.toLocaleString(document.documentElement.lang, {
    style: 'currency',
    currency: 'EUR',
  });
}
